import styled from 'styled-components';

export const TrustMiniSiteCategorySitesError = styled.div`
  color: var(--rednegative);
  margin-bottom: var(--s3);
`;
